import ActivityPopup from '@/components/btBox/ActivityPopup.vue';

const appList = [
  {
    name: '玩心手游',
    type: 1,
    localUrl: 'wxsy://com.hzwx.wx.box/app/moreGift',
    downloadUrl: 'http://pop.ad.wxbz123.cn/Planlist/ad?id=65f17a43c25506055c2a56d3'
  },
  {
    name: '变态猫游戏',
    type: 2,
    localUrl: 'wxbt://com.hzwx.bt.box/app/moreGift',
    downloadUrl: 'http://pop.ad.wxbz123.cn/Planlist/ad?id=65f1774dc2550605546d9fd2'
  },
  {
    name: 'iOS玩心手游',
    type: 3,
    localUrl: 'com.wxbzsyhz://platform-box-h5-ios.hzwxbz2.cn',
    // 这里的下载链接从 query 中拼接
    // downloadUrl: 'http://pop.ad.wxbz123.cn/Planlist/ad?id=65f1774dc2550605546d9fd2'
  },
]

export default {
  data () {
    return {
      visible: false,
      feedbackType: 0,
      urlScheme: '',
    }
  },
  components: {
    ActivityPopup,
  },
  computed: {
    idx () {
      return this.$route.query.app || 0
    },
    routePath () {
      // ?routePath=/task/SignInNewActivity&extraParams={aa: 1}
      return this.$route.query.routePath
    },
    extraParams () {
      return this.$route.query.extraParams
    },
    curApp () {
      return appList[this.idx]
    },
    // 这里的键名对应 popup 的 props
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '跳转',
          message: [
            `请求跳转到${this.curApp.name}`,
          ],
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          onSure: () => {
            this.createIframe()
            this.triggerVisible(false)
            setTimeout(() => {
              this.openDownload()
            }, 5 * 1000)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '下载',
          message: [`未检测到${this.curApp.name}，是否下载？`],
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          onSure: () => {
            this.handleDownload()
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
      ]
    },
  },
  methods: {
    init () {
      this.checkAppInstalled()


      setTimeout(() => {
        this.triggerVisible(true, 0)
      }, 500)
    },
    createUrlScheme () {
      const searchQuery = new URLSearchParams()
      let Url = this.curApp.localUrl
      if (this.routePath) {
        // iOS 盒子是俺做处理，所以直接添加到后面
        if (this.curApp.type === 3) {
          Url += this.routePath
        } else {
          searchQuery.set('routePath', this.routePath)
        }
      }
      if (this.extraParams) {
        searchQuery.set('extraParams', this.extraParams)
      }
      const query = searchQuery.toString()
      return `${Url}${query ? `?${query}` : ''}`
    },
    createIframe () {
      const urlScheme = this.createUrlScheme()
      this.urlScheme = urlScheme
      const iframe = document.createElement('iframe');
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.display = 'none';
      iframe.src = urlScheme;
      setTimeout(() => {
        document.body.appendChild(iframe);
        window.location.href = urlScheme
      }, 100)

      iframe.onload = function () {
        console.log('iframe onload')
      }

      return iframe
    },

    // 检测是否安装
    checkAppInstalled () {
      const t = Date.now()
      const iframe = this.createIframe()
      setTimeout(() => {
        const gap = Date.now() - t
        console.log('gap==>', gap)
        if (gap < 3200) {
          document.body.removeChild(iframe);
        }
      }, 3000);
    },

    triggerVisible (visible, type) {
      // 当目前正在展示，则不要覆盖
      if (visible && this.visible) return
      // 当上次 type 是 0，关闭后
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },

    openDownload () {
      this.triggerVisible(true, 1)
    },
  }
}